/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./BinTransferReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
// fExecuteAPI
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  ReportTitle,
  ReportRemoveSequenceChar,
  ReportUrl,
  fAlertToast,
} from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebBinTransferReportData,
  sWebBetweenReportArr,
  GetWMSMISAttributes,
  fValidationHead_Client,
  fValidationDetail_Client,
} from "./BinTransferReportAction";

import * as React from "react";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";

export default function BinTransferReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const sBufferObjInit = {
    sDetailReportRadioBtnName: "BINTSFRSMRY",
  };

  const [sBufferObj, setBufferObj] = useState(sBufferObjInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);
  const [sStatusData, setStatusData] = useState([]);

  //Detail
  const DetailReportRadioBtn = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailReportRadioBtnName: e.target.value,
    }));
  };

  //Head

  const fStatus = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sStatus: e.target.value,
    }));
  };

  const fDate = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDate: e.target.value,
      sFromDate: new Date(),
      sToDate: new Date(),
    }));
  };
  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: e?.$d,
      }));
    }
  };

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
    if (value?.length <= 0) {
      fLocation_Focus();
    }
  };
  const fLocation_Focus = (value) => {};

  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
    setBufferObj(sBufferObjInit);
    setHeadObject((obj) => ({
      ...obj,
      sStatus: sStatusData[0].Cd,
    }));
    // setPartyData([]);
    // setClusterData([]);
  };
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    let sReportTitle = "";

    let ReportTitleObj = {
      DateBetween:
        "Between " +
        moment(HeadObject.sFromDate).format("DD-MM-YYYY") +
        " and " +
        moment(HeadObject.sToDate).format("DD-MM-YYYY"),
      Location: HeadObject.sLocationName,
      Status: HeadObject.sStatus,
    };

    // Remove the trailing "&" character
    sReportTitle = ReportTitle(ReportTitleObj);

    let ReportUrlObj = {
      TrnTyp: sBufferObj.sDetailReportRadioBtnName,
      Date1: moment(HeadObject.sFromDate).format("MM-DD-YYYY"),
      Date2: moment(HeadObject.sToDate).format("MM-DD-YYYY"),
      Loc: HeadObject.sLocationPrnt,
      Status: HeadObject.sStatus,
    };

    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    // console.log("ReportUrlObj", ReportUrlObj);
    // console.log("sCurrentReport", sCurrentReport);

    console.log(
      "sCurrentReport",
      urlPrint + "/WMS/WMBinTransfer?" + sCurrentReport
    );
    setWebReportUrlModal(urlPrint + "/WMS/WMBinTransfer?" + sCurrentReport);
    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;
    let iValidationDetail_Client = fValidationDetail_Client(sBufferObj);
    if (!iValidationDetail_Client) return;
    await GetReportsView();
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    let iAttribute = await GetWMSMISAttributes(setLocationData, setStatusData);
    if (iAttribute?.status?.length > 0) {
      setHeadObject((obj) => ({
        ...obj,
        sStatus: iAttribute.status[0].Cd,
      }));
    }
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fFromDate={fFromDate}
                fToDate={fToDate}
                fDate={fDate}
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                sWebBinTransferReportData={sWebBinTransferReportData}
                sWebBetweenReportArr={sWebBetweenReportArr}
                HeadObject={HeadObject}
                fLocation={fLocation}
                fStatus={fStatus}
                sStatusData={sStatusData}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              className={vMediaQuery ? "hide-content" : " "}
            >
              <WmsContent
                DetailReportRadioBtn={DetailReportRadioBtn}
                xtitle={"Detail Report"}
                selectedOption={sBufferObj.sDetailReportRadioBtnName}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={4} sm={4} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid
              item
              xs={4}
              sm={4}
              md={"auto"}
              className={
                vMediaQuery ? "text-center" : "text-center hide-content"
              }
            >
              <CmpButton
                xbtnName="Detail"
                xOnClick={fSummary}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail Report"} onClose={fCloseSummaryModal} />

          <div className="py-3 px-2">
            <WmsContent
              DetailReportRadioBtn={DetailReportRadioBtn}
              xtitle={"Detail Report"}
              selectedOption={sBufferObj.sDetailReportRadioBtnName}
            />
          </div>
        </Box>
      </Modal>

      {/* webReport  */}

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
